import { useNavigate } from 'react-router-dom';

export default function MoringaSection() {
  const navigate = useNavigate();

  const benefits = [
    { icon: 'ri-heart-pulse-line', label: 'Rich in Vitamins & Minerals' },
    { icon: 'ri-shield-check-line', label: 'Antioxidant Powerhouse' },
    { icon: 'ri-seed-line', label: '100% Pure & Natural' },
    { icon: 'ri-recycle-line', label: 'Sustainably Sourced in Ghana' },
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Badge */}
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center bg-green-50 text-green-700 text-xs font-semibold px-4 py-1.5 rounded-full border border-green-200 uppercase tracking-widest">
            <i className="ri-star-line mr-2"></i>New Product
          </span>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* Image Side */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-green-100 to-lime-50 rounded-3xl -z-10"></div>
            <div className="rounded-2xl overflow-hidden w-full h-[480px]">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_e17d2c62eadfd03030c4db97e8f52ea6_45dfadd7.jpg"
                alt="Pure Moringa Powder by MY AVA Farms Ghana"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-green-600 text-white rounded-2xl px-6 py-4">
              <p className="text-xs font-medium opacity-80 uppercase tracking-wider">100% Pure</p>
              <p className="text-lg font-bold">Moringa Powder</p>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-4">
              Introducing Our <span className="text-green-600">Pure Moringa</span> Powder
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Harvested fresh from our farms in Ghana and carefully processed to retain maximum nutrients, 
              our pure moringa powder is a natural superfood packed with vitamins, minerals, and antioxidants. 
              Perfect for daily wellness, smoothies, cooking, and more.
            </p>

            {/* Benefits Grid */}
            <div className="grid grid-cols-2 gap-4 mb-10">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3 bg-green-50 rounded-xl px-4 py-3">
                  <div className="w-8 h-8 flex items-center justify-center text-green-600 shrink-0">
                    <i className={`${benefit.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-800">{benefit.label}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="https://paystack.shop/pay/v9-4hu3n50"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shopping-bag-line mr-2 text-lg"></i>
                Order Now
              </a>
              <button
                onClick={() => navigate('/products')}
                className="inline-flex items-center text-gray-700 hover:text-green-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </div>

            <p className="mt-4 text-sm text-gray-500 flex items-center gap-2">
              <i className="ri-map-pin-line text-green-600"></i>
              Proudly grown &amp; processed in Ghana &mdash; available for local &amp; export orders
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
